/** Colores de recuadros a partir del color de cabecera de la guía. */

function parseHex(hex) {
	let h = String(hex || "")
		.replace("#", "")
		.trim();
	if (h.length === 3) {
		h = h
			.split("")
			.map((c) => c + c)
			.join("");
	}
	if (h.length !== 6) {
		return { r: 222, g: 86, b: 36 };
	}
	return {
		r: parseInt(h.slice(0, 2), 16),
		g: parseInt(h.slice(2, 4), 16),
		b: parseInt(h.slice(4, 6), 16),
	};
}

function mixHex(a, b, amountB) {
	const A = parseHex(a);
	const B = parseHex(b);
	const m = (x, y) => Math.round(x + (y - x) * amountB);
	const to = (n) => n.toString(16).padStart(2, "0");
	return `#${to(m(A.r, B.r))}${to(m(A.g, B.g))}${to(m(A.b, B.b))}`;
}

export function getGuideAccent(headerBackgroundColor, fallback = "#de5624") {
	const hex = headerBackgroundColor || fallback;
	return {
		accent: hex,
		boxBg: mixHex(hex, "#ffffff", 0.86),
		boxBorder: mixHex(hex, "#ffffff", 0.22),
		tooltipBg: mixHex(hex, "#ffffff", 0.9),
		tooltipBorder: mixHex(hex, "#ffffff", 0.38),
	};
}
